module.exports = "./img/778274ce504478249349d8eed7c70148.jpg";